module.exports = __webpack_public_path__ + "media/images/flags/16/Sweden-ae7884399b55fdfe1eda45a2844f9a43.png";